export default "__VITE_ASSET__BecUQm8j__"